
import React from "react";
import { useTranslation } from "react-i18next";
import { List } from "semantic-ui-react";

export default function GenericRateCell(props) {
    const { t } = useTranslation();
    return (
      <>
        <List size="large">
          <List.Item>
              <List.Icon name='dollar' color='blue' />
              <List.Content >
              <List.Header >{props.rate}</List.Header>
              </List.Content>
          </List.Item>
        </List>
      </>
    );
  }
  